import axios from '@/api/axios'

const createRole = roleInput => {
  return axios.post('/roles', roleInput)
}

const getRoles = () => {
  return axios.get('/roles')
}

const getRole = id => {
  return axios.get(`/roles/${id}`)
}

const updateRole = (id, roleInput) => {
  return axios.put(`/roles/${id}`, roleInput)
}

const deleteRole = id => {
  return axios.delete(`/roles/${id}`)
}

export default {
  createRole,
  getRoles,
  getRole,
  updateRole,
  deleteRole
}
